/* EG: <Loader inline :phrase="'Checking...'"/> */

export default {
  name: 'loader',
  components: {},
  props: {
    phrase: {
      type: String,
      default: "",
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classObj: {
        flex: this.inline,
        "items-center": this.inline,
        "justify-center": this.inline
      }
    }
  },
  computed: {
    org () {
      return this.$store.getters.activeOrg
    },
    orgLogo () {
      if(this.org && this.org.logo.basic) {
        return this.org.logo.basic
      } else {
        return null
      }
    }
  },
  mounted () {

  },
  methods: {

  }
}
